(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-tel-input"] = factory();
	else
		root["vue-tel-input"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 